<template>
  <div class="rank-panel">
    <div class="filter-wrap">
      <div class="date-select select-wrapper">
        <select @change="onChangeSelect('type', $event)">
          <option
            v-for="item in types"
            :key="item"
            :value="item"
            :selected="item === filter.type">
            {{item}}
          </option>
        </select>
        <span class="select-label">{{types.find(item => { return item === filter.type })}}</span>
      </div>
      <div class="date-select select-wrapper">
        <select @change="onChangeSelect('onlineType', $event)">
          <option
            v-for="item in onlineTypes"
            :key="item"
            :value="item"
            :selected="item === filter.onlineType">
            {{item}}
          </option>
        </select>
        <span class="select-label">{{onlineTypes.find(item => { return item === filter.onlineType })}}</span>
      </div>
      <div class="date-select select-wrapper">
        <select @change="onChangeSelect('dateType', $event)">
          <option
            v-for="item in dateTypes"
            :key="item.value"
            :value="item.value"
            :selected="item.value === filter.dateType">
            {{item.name}}
          </option>
        </select>
        <span class="select-label">{{dateTypes.find(item =>{return item.value === filter.dateType}).name}}</span>
      </div>
      <div v-if="filter.dateType !== 'day'" class="date-select select-wrapper" style="width: 65px;">
        <select @change="onChangeSelect('year', $event)">
          <option
            v-for="year in targetYears"
            :key="year"
            :value="year"
            :selected="+year === +filter.year">
            {{year}}
          </option>
        </select>
        <span class="select-label">{{targetYears.find(item =>{return +item === +filter.year})}}</span>
      </div>
      <div v-if="filter.dateType !== 'day'" class="date-select select-wrapper" style="width: 70px;">
        <select @change="onChangeSelect('dateValue', $event)">
          <option
            v-for="item in dateValues"
            :key="item"
            :value="item"
            :selected="item === +filter.dateValue"
          >
            {{filter.dateType === 'week' ? `第${item}周` : `${item}月`}}
          </option>
        </select>
        <span class="select-label">{{filter.dateType === 'week' ? `第${filter.dateValue}周` : `${filter.dateValue}月`}}</span>
      </div>
      <div v-if="filter.dateType === 'day'" class="date-select select-wrapper">
        <select @change="onChangeSelect('dateValue', $event)">
          <option
            v-for="day in dateValues"
            :key="day"
            :value="day"
            :selected="day === filter.dateValue"
          >
            {{day}}
          </option>
        </select>
        <span class="select-label">{{filter.dateValue}}</span>
      </div>
    </div>

    <div class="date-list center mt10">
      <li
        v-for="item in targetTypes"
        :key="item.key"
        :class="['date-item', filter.target === item.key ? 'active' : '']"
        @click="onChangeSelect('target', item.key)"
      >
        {{item.title}}
      </li>
    </div>

    <div class="table-wrap">
      <div class="table-top-item">
        <div class="rank"></div>
        <div class="provider">合作方</div>
        <div class="profit_amount">利润</div>
        <div class="paid_amount">收入</div>
        <div class="subscribe_count">新增</div>
        <div class="arpu">ARPU</div>
      </div>
      <div v-for="(item, index) in tableDatas" :key="`${index}-${item.provider}`" class="table-item">
        <div class="rank">{{index + 1}}</div>
        <div class="provider">{{item.provider}}</div>
        <div class="profit_amount">{{item.profitAmount.toFixed(1)}}</div>
        <div class="paid_amount">{{item.paidAmount}}</div>
        <div class="subscribe_count">{{item.subscribeCount}}</div>
        <div class="arpu">{{item.ARPU.toFixed(1)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Dushu from '@/engine/Dushu'

const getDateValues = (vm) => {
  const { year, dateType } = vm.filter;
  const dateTime = moment().year(year);
  switch (dateType) {
    case 'day':
      let index = 0; // eslint-disable-line
      const dateValues = []; // eslint-disable-line
      while (index <= moment().diff('2020-01-01', 'd')) {
        dateValues.push(moment().subtract(index, 'd').format('YYYY-MM-DD'));
        index++;
      }
      vm.dateValues = dateValues;
      break;
    case 'week':
    case 'month':
      const length = dateType === 'week' ? dateTime.isoWeeksInYear() : 12; // eslint-disable-line
      vm.dateValues = Array.from({ length }, (item, index) => index + 1);
      break;
    default:
      break;
  }
}

const formatDateValue = (filter) => {
  const { year, dateType, dateValue } = filter;
  const dateTime = moment().year(year);
  let dates = [];
  switch (dateType) {
    case 'day':
      dates = [moment(dateValue).format('YYYY-MM-DDT00:00:00ZZ'), moment(dateValue).format('YYYY-MM-DDT00:00:00ZZ')]
      break;
    case 'week':
      dates = [dateTime.isoWeek(dateValue).startOf('isoWeek').format('YYYY-MM-DDT00:00:00ZZ') ,
        dateTime.isoWeek(dateValue).endOf('isoWeek').format('YYYY-MM-DDT00:00:00ZZ')]
      break;
    case 'month':
      dates = [dateTime.set('month', dateValue - 1).date(1).format('YYYY-MM-DDT00:00:00ZZ'),
        dateTime.set('month', dateValue - 1).endOf('month').format('YYYY-MM-DDT00:00:00ZZ')]
      break;
    default:
      break;
  }

  return dates;
}

const fetchRankData = (vm) => {
  const { target, type, onlineType } = vm.filter;
  const [startDate, endDate] = formatDateValue(vm.filter);
  const params = {
    startDate, endDate, orderBy: target,
    providerTypes: type === '全部'? undefined: [type],
    onlineTypes: onlineType === '全部'? undefined: [onlineType]
  };
  Dushu.getProviderStatisticsRanked(params).then(data => {
    vm.tableDatas = ((data || {}).items || []).filter((item) => {
      return item.subscribeCount && item.paidAmount && item.ARPU;
    });
  })
}

export default {
  name: 'RankPanel',
  props: {
    providerTypes: Array,
  },
  mounted () {
    this.providerTypes[this.providerTypes.length - 1] = 'Youtube';
    this.types = ['全部', ...this.providerTypes];
    const yearDiff = Math.ceil(moment().diff(moment('2020-01-01'), 'years', true));
    this.targetYears = Array.from({ length: yearDiff }, (item, index) => index + 2020);

    fetchRankData(this);
  },
  data() {
    return {
      types: ['全部'],
      onlineTypes: ['全部', '老客户', '新客户'],
      dateTypes: [{ value: 'day', name: '按天查看' }, { value: 'week', name: '按周查看' }, { value: 'month', name: '按月查看' }],
      targetTypes: [
        { title: '利润', key: 'profit_amount' },
        { title: '收入', key: 'paid_amount' },
        { title: '新增', key: 'subscribe_count' },
        { title: 'ARPU', key: 'arpu' },
      ],
      dateValues: Array.from({ length: 12 }, (item, index) => index + 1),
      targetYears: [],
      filter: {
        type: '全部',
        onlineType: '全部',
        year: moment().year(),
        dateType: 'month',
        dateValue: moment().month() + 1,
        target: 'profit_amount',
      },
      tableDatas: [],
    }
  },
  methods: {
    onChangeSelect: function (type, event) {
      const value = event.target ? event.target.value : event;
      this.filter[type] = value;
      getDateValues(this);
      if (type === 'dateType') {
        const dateTime = moment().year(this.filter.year);
        switch (value) {
          case 'day':
            this.filter.dateValue = moment().format('YYYY-MM-DD');
            break;
          case 'week':
            this.filter.dateValue = dateTime.isoWeeks();
            break;
          case 'month':
            this.filter.dateValue = dateTime.get('month') + 1;
            break;
          default:
            break;
        }
      }

      fetchRankData(this);
    },
  },
};
</script>

<style scoped lang="scss">
.table-item,
.table-top-item {
  display: flex;
  border-bottom: 1px solid #ddd;
  text-align: center;
  margin: 0 10px;
  font-size: 14px;

  .rank,
  .provider,
  .paid_amount,
  .subscribe_count,
  .arpu,
  .profit_amount {
    border-right: 1px solid #ddd;
    height: 30px;
    line-height: 30px;
  }

  .rank {
    width: 30px;
    border-left: 1px solid #ddd;
  }

  .provider {
    width: calc(100% - 270px);
    text-align: start;
    padding: 0 5px;
    font-size: 12px;
    line-height: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .paid_amount,
  .profit_amount {
    width: 70px;
  }

  .subscribe_count,
  .arpu {
    width: 50px;
  }
}

.table-top-item {
  border-top: 1px solid #ddd;
  font-weight: bold;
  background: #ccc;

  .provider {
    text-align: center;
  }
}
</style>
